<template>
  <div class="registration-page">
    <div class="registration-page-container">
      <div class="section">
        <div class="section-header"><h3>가입자</h3></div>
        <div class="section-body">
          <dl class="field-group">
            <dt class="field-label">
              <label for="customer-type-confirmed">고객구분</label>
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p id="customer-type-confirmed" class="data-text">
                  {{ custKdNm }}
                </p>
              </div>
            </dd>
          </dl>
          <dl class="field-group">
            <dt class="field-label">
              <label for="customer-name-confirmed">가입자명</label>
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p id="customer-name-confirmed" class="data-text">
                  {{ registration.aplcNmMask }}
                </p>
              </div>
            </dd>
          </dl>
          <dl class="field-group">
            <dt class="field-label">
              <label for="available-customer-tel-number-confirmed"
                >연락가능 전화번호</label
              >
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p
                  id="available-customer-tel-number-confirmed"
                  class="data-text"
                >
                  {{ retrieveData.aplcTlnoMask }}
                </p>
              </div>
            </dd>
          </dl>
          <dl class="field-group">
            <dt class="field-label">
              <label for="customer-id-number-confirmed">주민등록번호</label>
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p id="customer-id-number-confirmed" class="data-text">
                  <span>{{ ssn1 }}</span>
                  <span class="field-group-space">-</span>
                  <span>{{ ssn2 }}</span>
                </p>
              </div>
            </dd>
          </dl>
          <dl class="field-group" v-if="entrRsvTruthInfo.onetIdcdDivsCd !== '' && registration.custKdCd !== 'A'">
            <dt class="field-label">
              <label for="">인증종류</label>
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p
                  class="data-text"
                  v-if="entrRsvTruthInfo.onetIdcdDivsCd === 'REGID'"
                >
                  <span>주민등록증</span>
                </p>
                <p
                  class="data-text"
                  v-if="entrRsvTruthInfo.onetIdcdDivsCd === 'HANDI'"
                >
                  <span>장애인등록증</span>
                </p>
                <p
                  class="data-text"
                  v-if="entrRsvTruthInfo.onetIdcdDivsCd === 'DRIVE'"
                >
                  <span>운전면허번호</span>
                </p>
                <p
                  class="data-text"
                  v-if="entrRsvTruthInfo.onetIdcdDivsCd === 'MERIT'"
                >
                  <span>국가유공자(10종)</span>
                </p>
                <p
                  class="data-text"
                  v-if="entrRsvTruthInfo.onetIdcdDivsCd === 'NAMEC'"
                >
                  <span>대한민국여권</span>
                </p>
                <p
                  class="data-text"
                  v-if="entrRsvTruthInfo.onetIdcdDivsCd === 'FORGN'"
                >
                  <span>외국인등록증</span>
                </p>
                
              </div>
            </dd>
          </dl>
          <dl
            class="field-group"
            v-if="entrRsvTruthInfo.onetIdcdDivsCd === 'DRIVE'"
          >
            <dt class="field-label">
              <label for="">운전면허번호</label>
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">
                  <span>{{ drvLcnsNo }}</span>
                </p>
              </div>
            </dd>
          </dl>
          <dl
            class="field-group"
            v-if="entrRsvTruthInfo.onetIdcdDivsCd === 'MERIT'"
          >
            <dt class="field-label">
              <label for="">보훈번호</label>
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">
                  <span>{{ entrRsvTruthInfo.monmCsntNo }}</span>
                </p>
              </div>
            </dd>
          </dl>
          <dl
            class="field-group"
            v-if="
              entrRsvTruthInfo.onetIdcdDivsCd &&
                entrRsvTruthInfo.onetIdcdDivsCd !== 'NAMEC'
            "
          >
            <dt class="field-label">
              <label for="">발급일자</label>
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">
                  <span>{{ year }}년 {{ month }}월 {{ day }}일 발급</span>
                </p>
              </div>
            </dd>
          </dl>
          <dl class="field-group">
            <dt class="field-label">
              <label for="customer-address-confirmed">고객주소</label>
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p id="customer-address-confirmed" class="data-text">
                  <span>{{ billDivsNm }}</span
                  ><br />
                  <span>
                    {{ registration.crplZpcd }}, {{ registration.crplAddr }}
                    <!-- 상세주소 제거 -->
                    <!-- {{ registration.crplDadr }} -->
                  </span>
                </p>
              </div>
            </dd>
          </dl>
          <dl class="field-group">
            <dt class="field-label">
              <label id="bill-type-confirmed">청구서선택</label>
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p id="bill-type-confirmed" class="data-text">
                  {{ bltxRcepMthdNm }}
                </p>
                <!--  2025-11-27 수정
                <ul class="notice-text-list">
                  <li class="notice-text">
                    e-mail(상세) 또는 휴대폰(간편) 신청 시 매월 무료문자
                    15건(300원)제공
                  </li>
                </ul>
                -->
              </div>
            </dd>
          </dl>
          <dl class="field-group">
            <dt class="field-label">
              <label for="customer-email-confirmed">e-mail</label>
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p id="customer-email-confirmed" class="data-text">
                  {{ registration.aplcEmalAddrMask }}
                </p>
                <ul class="notice-text-list">
                  <li class="notice-text">
                    가입예약 내용 및 e-mail(상세) 청구서를 받으시기 위해 필요한
                    것으로 정확한 이메일 주소를 입력해 주세요.
                  </li>
                </ul>
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { store } from '@/store'
import { getComCodeList } from '@/api/metaService'
export default {
  name: 'RegistrationStep3SectionCustomer',

  props: {
    registrationProps: Object,
    entrRsvTruthInfoProps: Object
  },

  data() {
    return {
      registration: {},
      entrRsvTruthInfo: {},
      year: '',
      month: '',
      day: '',
      driverRegionList: '',
      retrieveData: {
        aplcTlnoMask: ''
      }
    }
  },

  mounted() {
    this.registration = this.registrationProps
    this.entrRsvTruthInfo = this.entrRsvTruthInfoProps
    this.year = this.entrRsvTruthInfo.isuDt.substring(0, 4)
    this.month = this.entrRsvTruthInfo.isuDt.substring(4, 6)
    this.day = this.entrRsvTruthInfo.isuDt.substring(6, 8)
    Promise.all([getComCodeList('DRV_LCNS_ISUE_AREA_CD')]).then(
      responses => {
        this.driverRegionList = responses[0].data
      }
    )
    this.retrieveData.aplcTlnoMask = this.formatPhoneNumber(
      this.registration.aplcTlnoMask
    )
    // this.$store.state.step1.customer.emailId = this.emailId
    // this.$store.state.step1.customer.emailDomain = this.emailDomain
    this.$store.state.step1.customer.custKdCd = this.custKdCd
  },

  computed: {
    /** 
     * Function    : custKdNm
     * Description : 가입자 구분 이름 설정
     **/
    custKdNm() {
      if (
        this.registration.custKdCd === 'A' ||
        this.registration.custKdCd === 'B'
      ) {
        return '개인'
      }
      if (this.registration.custKdCd === 'C') {
        return '법인'
      }
      if (this.registration.custKdCd === 'D') {
        return '외국인'
      }
      return ''
    },

    /** 
     * Function    : ssn1
     * Description : 주민번호 앞자리
     **/
    ssn1() {
      return this.registration.aplcDernoMask
        ? this.registration.aplcDernoMask.substr(0, 6)
        : ''
    },

    /** 
     * Function    : ssn2
     * Description : 주민번호 뒷자리
     **/
    ssn2() {
      return this.registration.aplcDernoMask
        ? this.registration.aplcDernoMask.substr(6, 7)
        : ''
    },

    /** 
     * Function    : billDivsNm
     * Description : 청구 구분 이름
     **/
    billDivsNm() {
      if (this.registration.billDivsCd === 'H') {
        return '자택'
      }

      if (this.registration.billDivsCd === 'O') {
        return '직장'
      }

      if (this.registration.billDivsCd === 'E') {
        return '기타'
      }
      return ''
    },

    /** 
     * Function    : drvLcnsNo
     * Description : 운전면허번호 Formatting
     **/
    drvLcnsNo() {
      let drvLncs = this.entrRsvTruthInfo.drvLcnsNoMask
      let driverRegionName = ''
      for (let i = 0; i < this.driverRegionList.length; i++) {
        if (
          this.entrRsvTruthInfo.drvLcnsIsuAreaCd ===
          this.driverRegionList[i].cmmCdv
        ) {
          driverRegionName = this.driverRegionList[i].cmmCdvNm
          break
        }
      }
      return (
        driverRegionName +
        drvLncs.substring(0, 2) +
        '-' +
        drvLncs.substring(2, 8) +
        '-' +
        drvLncs.substring(8, 10)
      )
    },

    /** 
     * Function    : bltxRcepMthdNm
     * Description : 청구서 선택 이름
     **/
    bltxRcepMthdNm() {
      if (this.registration.bltxRcepMthdCd === '2') {
        return 'E-MAIL(청구서 내용 상세)'
      }
      if (this.registration.bltxRcepMthdCd === '5') {   // 휴대폰(청구서 내용 간편)  -> App 청구서 (2025.11.27)
          return 'App 청구서'
        }
      if (this.registration.bltxRcepMthdCd === '13') {  // [CSR ID:RITM2464842] 청구서유형 추가 (2025.11.27)
        return 'E-MAIL + App 청구서'
      }
      return ''
    }
  },
  methods: {
    /** 
     * Function    : formatPhoneNumber
     * Description : 휴대폰 번호 formatting
     **/
    formatPhoneNumber(phoneNum) {
      if (phoneNum.length === 10) {
        return (
          phoneNum.substring(0, 3) +
          '-' +
          phoneNum.substring(3, 6) +
          '-' +
          phoneNum.substring(6, 10)
        )
      } else {
        return (
          phoneNum.substring(0, 3) +
          '-' +
          phoneNum.substring(3, 7) +
          '-' +
          phoneNum.substring(7, 11)
        )
      }
    }
  }
}
</script>

<style scoped></style>
